import { useLocalStorage } from 'usehooks-ts'
import { options } from '../../RightSider'

const useLocalStorageValue = (localStorageKey: string): any => {

  const findDefaultValue = (key: string): boolean => {
    for (const group of options) {
      for (const option of group.options) {
        if (option.localStorageKey === key) {
          return option.defaultValue
        }
      }
    }
    return false
  }

  const [value] = useLocalStorage(localStorageKey, findDefaultValue(localStorageKey))

  return value
}

export default useLocalStorageValue
